/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoPhoneNumberLastFourFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input || input.length < 4) {
                return "";
            }
            return input.substring(input.length - 4);
        };
        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoPhoneNumberLastFourFilter", meevoPhoneNumberLastFourFilter);

}
